var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"level app-levelbar"},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('h3',{staticClass:"subtitle is-5"},[_c('strong',[_vm._v(_vm._s(_vm.name))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }